/* eslint-disable max-len */
import React, { ReactEventHandler } from 'react';
import {
  useLocation,
} from 'react-router-dom';

import NavLink from 'components/SideMenu/NavLink/NavLink';
import { useAppSelector } from 'hooks';
import { SETTINGS_BACK_KEY, SETTINGS_LINK_KEY, useCustomerLinks } from 'components/SideMenu/nav.config';
import { ReactComponent as Logo } from 'assets/images/logo-2-color-no-padding.svg';
import ProjectSelector from 'components/Project/ProjectSelector/ProjectSelector';
import styles from './SideMenu.module.scss';

export interface ISideMenuProps {
  handleMenuToggle: ReactEventHandler
}

const SideMenu = () => {
  const location = useLocation();
  const { user, storage, projects } = useAppSelector((state) => state);

  const links = useCustomerLinks(user, !!storage.isStorageActive, projects.users.length === 0 && projects.list.length === 0);

  const currentSection = location.pathname.split('/').splice(0, 2)[1];

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const settingsLink = React.useMemo(() => links.mainLinks.get(SETTINGS_LINK_KEY)?.[0], [links]);
  const settingsBackLink = React.useMemo(() => links.settingsLinks.get(SETTINGS_BACK_KEY)?.[0], [links]);

  return (
    <aside className={styles.sideMenu}>
      {currentSection === 'services' && (
        <nav className={styles.linksList}>
          <Logo className={styles.logo} />
          <ProjectSelector />
          <ul>
            {Array.from(links.mainLinks).map(([section, sectionLinks]) => (
              <React.Fragment key={section.id}>
                {section.title && !sectionLinks.every((link) => link.hidden) && <li className={styles.sectionTitle}>{section.title}</li>}
                {sectionLinks.map((link) => (
                  <li key={link.path}>
                    <NavLink
                      className={link.className}
                      path={link.path}
                      Icon={link.Icon}
                      disabled={link.disabled}
                      hidden={link.hidden}
                      title={link.title}
                      qaElement={`nav_link_${link.path.split('/').slice(-1)[0]}`}
                    />
                  </li>
                ))}
              </React.Fragment>
            ))}
          </ul>
          {settingsLink && (
          <div className={styles.settingsLink}>
            <NavLink
              className={settingsLink.className}
              path={settingsLink.path}
              Icon={settingsLink.Icon}
              disabled={settingsLink.disabled}
              title={settingsLink.title}
              qaElement={`nav_link_${settingsLink.path.split('/').slice(-1)[0]}`}

            />
          </div>
          )}
        </nav>
      )}
      {currentSection === 'settings' && (
        <nav className={styles.linksList}>
          {settingsBackLink && (
          <div className={styles.settingsBackLink}>
            <NavLink
              className={settingsBackLink.className}
              path={settingsBackLink.path}
              Icon={settingsBackLink.Icon}
              disabled={settingsBackLink.disabled}
              title={settingsBackLink.title}
              qaElement="nav_link_back_to_services"
            />
          </div>
          )}
          <ul>
            {Array.from(links.settingsLinks).map(([section, sectionLinks]) => (
              <React.Fragment key={section.id}>
                {section.title && <li className={styles.sectionTitle}>{section.title}</li>}
                {sectionLinks.map((link) => (
                  <li key={link.path}>
                    <NavLink
                      className={link.className}
                      path={link.path}
                      Icon={link.Icon}
                      disabled={link.disabled}
                      hidden={link.hidden}
                      title={link.title}
                      qaElement={`nav_link_${link.path.split('/').slice(-1)[0]}`}
                    />
                  </li>
                ))}
              </React.Fragment>
            ))}
          </ul>
        </nav>
      )}
    </aside>
  );
};

export default SideMenu;
